import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyProfileComponent } from '../company-profile/company-profile.component';
import { SolutionPortfolioComponent } from '../solution-portfolio/solution-portfolio.component';
import { EditionsComponent } from '../editions/editions.component';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { PageFooterComponent } from '../page-footer/page-footer.component';
import { NotesComponent } from '../notes/notes.component';
import { SpacesService } from '../../services/spaces.service';
import { Space } from '../../models/space.model';
import { SpaceConfigOptionsService } from '../../services/space-config-options.service';

@Component({
  selector: 'app-company-fit',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PageHeaderComponent,
    PageFooterComponent,
    NotesComponent,
    CompanyProfileComponent,
    SolutionPortfolioComponent,
    EditionsComponent
  ],
  templateUrl: './company-fit.component.html',
  styleUrl: './company-fit.component.scss'
})
export class CompanyFitComponent implements OnInit {
  @Input() showNotes = false;
  space: Space | null = null;
  normalizedIndustries: string[] = [];
  suggestedEditionIds: string[] = [];
  initialSolutions: string[] = [];

  constructor(
    private readonly spacesService: SpacesService,
    private readonly spaceConfigOptions: SpaceConfigOptionsService
  ) {}

  ngOnInit(): void {
    this.initialSolutions = this.spacesService.getSelectedSolutions();
    this.spacesService.activeSpace$.subscribe((space) => {
      this.space = space;
      this.normalizedIndustries = this.normalizeIndustryIds(space.relevantIndustries);
    });
  }

  onIndustriesChange(industries: string[]): void {
    this.spacesService.updateActiveSpaceIndustries(this.normalizeIndustryIds(industries));
  }

  onDisciplinesChange(disciplines: string[]): void {
    this.spacesService.updateActiveSpaceDisciplines(disciplines);
  }

  onMaterialsChange(materials: string[]): void {
    this.spacesService.updateActiveSpaceMaterials(materials);
  }

  onSelectedSolutionsChange(solutionNames: string[]): void {
    this.spacesService.updateSelectedSolutions(solutionNames);
  }

  onSuggestedEditionIdsChange(ids: string[]): void {
    this.suggestedEditionIds = ids;
  }

  private normalizeIndustryIds(values: string[]): string[] {
    return [...new Set(values.map(v => this.spaceConfigOptions.normalizeIndustryId(v)))];
  }
}
